export default function CurrentlySection() {
  return (
    <section className="currently">
      <div className="container">
        <span className="currently-decoration" aria-hidden="true">&#10024;</span>
        <div className="currently-label">Current State of Mind</div>
        <div className="currently-grid">
          <div className="currently-item">
            <h4>
              <span className="currently-icon" role="img" aria-label="terminal">&#128187;</span>
              Building
            </h4>
            <p>Fine-tuning specialized AI agents for creative workflow automation and architectural design patterns.</p>
          </div>
          <div className="currently-item">
            <h4>
              <span className="currently-icon" role="img" aria-label="map">&#128506;</span>
              Exploring
            </h4>
            <p>Planning a slow-travel journey through the coastal towns of Portugal, searching for the perfect Pastéis de Nata.</p>
          </div>
          <div className="currently-item">
            <h4>
              <span className="currently-icon" role="img" aria-label="book">&#128214;</span>
              Reading
            </h4>
            <p>Currently on book 4 of reading through my entire book collection before I give it away.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
